/** Catálogo de ícones da biblioteca de curiosidades da Lore. */

/** Ícones com cores próprias — não recebem tint do tema. */
export const LORE_CURIOSITY_COLORFUL_ICONS = [
  { path: '/icons/oldtopman.svg', label: 'Old Topman' },
  { path: '/icons/trade.svg', label: 'Trade' },
] as const;

/** Ícones monocromáticos — azul no picker; cor do tema na página. */
export const LORE_CURIOSITY_TINTED_ICONS = [
  { path: '/icons/power.svg', label: 'Power' },
  { path: '/icons/power2.svg', label: 'Power 2' },
  { path: '/icons/pawn.svg', label: 'Peão' },
  { path: '/icons/smile.svg', label: 'Smile' },
  { path: '/icons/ace.svg', label: 'Ace' },
  { path: '/icons/aceslogo.svg', label: 'Aces' },
  { path: '/icons/tradeicon2.svg', label: 'Trade 2' },
  { path: '/icons/grouppowers.svg', label: 'Group powers' },
  { path: '/icons/equipe.svg', label: 'Equipe' },
  { path: '/icons/user.svg', label: 'User' },
  { path: '/icons/adduser.svg', label: 'Add user' },
  { path: '/icons/userconfig.svg', label: 'User config' },
  { path: '/icons/usermore.svg', label: 'User more' },
] as const;

const COLORFUL_PATHS = new Set<string>(LORE_CURIOSITY_COLORFUL_ICONS.map((i) => i.path));

export function normalizeLoreIconPath(path: string): string {
  const v = path.trim();
  if (v.startsWith('/')) return v;
  if (v.startsWith('icons/')) return `/${v}`;
  if (/\.svg$/i.test(v)) return `/icons/${v.replace(/^\/+/, '')}`;
  return v;
}

export function isLoreCuriosityColorfulIcon(path: string): boolean {
  return COLORFUL_PATHS.has(normalizeLoreIconPath(path));
}

/** Cor dos ícones monocromáticos dentro dos cards de curiosidade (âmbar). */
export const LORE_CURIOSITY_ICON_TINT = '#fbbf24';
